// extracted by mini-css-extract-plugin
module.exports = {"navItem":"NavItem_navItem__0RWp5","selected":"NavItem_selected__ZvmER"};